// src/components/prospectos/ModalVisitasProspecto.js
import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import Modal from "../Modal";

const ModalVisitasProspecto = ({ prospecto, cerrar }) => {
  const { token } = useContext(AuthContext);

  const [visitas, setVisitas] = useState([]);
  const [comentarios, setComentarios] = useState("");
  const [miembros, setMiembros] = useState([]);
  const [idMiembro, setIdMiembro] = useState("");

  // Cargar visitas del prospecto
  const cargarVisitas = async () => {
    try {
      const res = await fetch(
        `/api/visitas-prospecto/${prospecto.id_prospecto}`,
        { credentials: "include", headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await res.json();
      const visitasOrdenadas = data.sort(
        (a, b) => new Date(a.fecha_visita) - new Date(b.fecha_visita)
      );
      setVisitas(visitasOrdenadas);
    } catch (error) {
      console.error(error);
      setVisitas([]);
    }
  };

  // Cargar lista de miembros
  const cargarMiembros = async () => {
    try {
      const res = await fetch("/api/miembros", {
        credentials: "include",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setMiembros(data || []);
    } catch (error) {
      console.error(error);
      setMiembros([]);
    }
  };

  useEffect(() => {
    cargarVisitas();
    cargarMiembros();
  }, []);

  // Guardar visita
  const guardarVisita = async () => {
    if (!idMiembro) {
      alert("Selecciona un miembro responsable");
      return;
    }
    try {
      await fetch("/api/visitas-prospecto", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id_prospecto: prospecto.id_prospecto,
          id_miembro: idMiembro,
          comentarios,
          fecha_visita: new Date().toISOString(),
        }),
      });
      setComentarios("");
      setIdMiembro("");
      cargarVisitas();
    } catch (error) {
      console.error(error);
    }
  };

  // Obtener nombre del miembro por id
  const nombreMiembro = (id) => {
    const miembro = miembros.find(
      (m) => m.id_miembro === id || m.id_usuario === id
    );
    return miembro
      ? ` ${miembro.nombre} ${miembro.paterno || ""}`
      : "-";
  };

  // Función para mostrar badge de visita
  const badgeVisita = (index) => {
    const suffix = ["Primera", "Segunda", "Tercera", "Cuarta"];
    return suffix[index] || `${index + 1}ª`;
  };

  // Formatear fecha a dd/mm/yyyy
  const formatearFecha = (fechaStr) => {
    const fecha = new Date(fechaStr);
    return `${fecha.getDate().toString().padStart(2, "0")}/${(
      fecha.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${fecha.getFullYear()}`;
  };

  return (
    <Modal open={true} onClose={cerrar} title={`Visitas - ${prospecto.nombre}`} maxWidth="max-w-4xl">
        <div className="space-y-5">
          {/* Formulario de nueva visita */}
          <div className="bg-slate-50 rounded-lg border border-slate-200 p-4">
            <h3 className="text-sm font-semibold mb-3 text-slate-800">Registrar nueva visita</h3>
            <select
              className="w-full border border-slate-200 rounded-lg mb-2 px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400"
              value={idMiembro}
              onChange={(e) => setIdMiembro(e.target.value)}
            >
              <option value="">-- Selecciona quien realizó la visita --</option>
              {miembros.map((m) => (
                <option key={m.id_miembro || m.id_usuario} value={m.id_miembro || m.id_usuario}>
                  {m.nombre} {m.paterno || ""}
                </option>
              ))}
            </select>

            <textarea
              className="w-full border border-slate-200 rounded-lg mb-3 px-3 py-1.5 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400"
              placeholder="Comentarios"
              rows={2}
              value={comentarios}
              onChange={(e) => setComentarios(e.target.value)}
            />

            <button
              className="px-3.5 py-1.5 text-sm rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white font-medium transition"
              onClick={guardarVisita}
            >
              Guardar visita
            </button>
          </div>

          {/* Historial */}
          <div>
            <h3 className="text-sm font-semibold mb-2 text-slate-800">Historial de visitas</h3>
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-slate-50 text-xs uppercase text-slate-500">
                    <tr>
                      <th className="px-4 py-2.5 text-left font-semibold">#</th>
                      <th className="px-4 py-2.5 text-left font-semibold">Fecha</th>
                      <th className="px-4 py-2.5 text-left font-semibold">Visitó</th>
                      <th className="px-4 py-2.5 text-left font-semibold">Comentarios</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visitas.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="text-center py-8 text-slate-400">
                          No hay visitas registradas
                        </td>
                      </tr>
                    ) : (
                      visitas.map((v, index) => (
                        <tr key={v.id_visita} className="border-t border-slate-100 hover:bg-slate-50 transition">
                          <td className="px-4 py-2.5">
                            <span className="bg-indigo-50 text-indigo-600 px-2 py-0.5 rounded-full text-xs font-semibold">
                              {badgeVisita(index)}
                            </span>
                          </td>
                          <td className="px-4 py-2.5 text-slate-600">{formatearFecha(v.fecha_visita)}</td>
                          <td className="px-4 py-2.5 text-slate-600">{nombreMiembro(v.id_miembro)}</td>
                          <td className="px-4 py-2.5 text-slate-600">{v.comentarios}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
    </Modal>
  );
};

export default ModalVisitasProspecto;